"use client";

import { NotAuthenticated } from "@/auth/components/NotAuthenticated";
import { usePathname, useSearchParams } from "next/navigation";

export function ClientNotAuthenticated({ loginUrl }: { loginUrl?: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const callbackUrl =
    pathname + (searchParams.size ? `?${searchParams.toString()}` : "");

  return <NotAuthenticated loginUrl={loginUrl} callbackUrl={callbackUrl} />;
}
